import { PacSupporterSelect } from "@/components"
import React from "react"
import { useStyles } from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal/PayrollFormModal.styles"
import { useFormContext } from "react-hook-form"
import ButtonViewProfile from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal/ButtonViewProfile"

export const CancelPayrollForm = () => {
    const { classes } = useStyles()
    const { watch } = useFormContext()
    const contact = watch("contact")

    return (
        <>
            <div className={classes.stackFullCol}>
                <div className={classes.contactButton}>
                    <PacSupporterSelect
                        name="contact"
                        label="Select contact"
                        placeholder="Select contact"
                        withAsterisk
                        multi={false}
                        clearable
                        rules={{ required: "You must select a Contact" }}
                        // We must be able to cancel payroll deductions for supporters after they have been marked ineligible
                        permanentFilter={{ for_pac_eligibilities: undefined }}
                    />
                </div>
                <ButtonViewProfile contact={contact} />
            </div>
        </>
    )
}
